import React, { useState } from 'react'
import service1 from 'assets/images/servico (1).png'
import service2 from 'assets/images/servico (2).jpg'
import service3 from 'assets/images/servico (3).png'
import service4 from 'assets/images/servico (4).png'
import service5 from 'assets/images/servico (5).png'
import service6 from 'assets/images/servico (6).png'
import service7 from 'assets/images/servico (7).png'
import service8 from 'assets/images/servico (8).png'
import service9 from 'assets/images/servico (9).png'
import service10 from 'assets/images/servico (10).jpg'

function OurServices() {
  // Estado que controla qual card está expandido (null significa nenhum aberto)
  const [expandedIndex, setExpandedIndex] = useState(null)

  const toggleExpand = (index) => {
    // Se o card já estiver aberto, fecha-o; caso contrário, expande o selecionado.
    setExpandedIndex((prevIndex) => (prevIndex === index ? null : index))
  }

  const services = [
    {
      name: 'antecipacao-fgts',
      title: 'Receba seu FGTS em Minutos!',
      description:
        'Antecipe seu FGTS de forma rápida e sem complicações. Com essa opção, o crédito cai na sua conta em poucos minutos, ideal para quem precisa de recursos imediatos. Exclusivo para trabalhadores com carteira CLT, essa solução agiliza o acesso ao seu benefício, permitindo que você aproveite suas vantagens financeiras exatamente quando precisar.',
      image: service1,
    },
    {
      name: 'credito-pessoal',
      title: 'Garanta Seu Crédito Sem Burocracia!',
      description:
        'Obtenha crédito rápido e sem burocracia com nosso Crédito Pessoal. Com liberação em até 2 horas e o primeiro pagamento somente após 45 dias, essa solução 100% digital foi pensada para colocar suas contas em dia e ajudar você a realizar seus sonhos.',
      image: service2,
    },
    {
      name: 'credito-consignado',
      title: 'Ative Seu Crédito Consignado!',
      description:
        'Se você é aposentado, pensionista ou servidor público, o Crédito Consignado é a solução ideal para acessar o crédito de forma simples e descomplicada. Com parcelas descontadas automaticamente do seu benefício ou da folha de pagamento, essa modalidade proporciona condições especiais, taxas reduzidas e prazos flexíveis que se ajustam ao seu orçamento. Assim, você pode cuidar das suas finanças com tranquilidade, sem enfrentar a burocracia tradicional.',
      image: service3,
    },
    {
      name: 'cartao-consignado',
      title: 'Garanta Seu Cartão Exclusivo!',
      description:
        'Tenha acesso ao Cartão Consignado, exclusivo para beneficiários do INSS e servidores públicos. Mesmo para quem está com o nome negativado, esse cartão oferece isenção de anuidade, descontos em farmácias, saques de até 70% do limite e a possibilidade de dobrar o valor do saque e do limite, sempre respeitando a sua capacidade financeira.',
      image: service4,
    },
    {
      name: 'credito-garantia-veiculo',
      title: 'Transforme Seu Veículo em Crédito!',
      description:
        'Realize seus projetos utilizando seu veículo como garantia. Com essa solução, você pode receber até 80% do valor do seu veículo, possibilitando condições vantajosas sem precisar abrir mão do seu bem.',
      image: service5,
    },
    {
      name: 'credito-garantia-imovel',
      title: 'Desbloqueie Crédito com Seu Imóvel!',
      description:
        'Realize seus projetos utilizando seu imóvel como garantia. Com essa solução, você pode optar por um empréstimo com garantia de imóvel, com prazos que podem chegar a 240 meses e juros mais baixos, possibilitando condições vantajosas sem precisar abrir mão do seu bem.',
      image: service6,
    },
    {
      name: 'financiamento-veiculos',
      title: 'Financie o Carro dos Seus Sonhos!',
      description:
        'Na hora de adquirir o veículo dos seus sonhos, nosso Financiamento de Veículos é a opção ideal. Financiamos desde veículos usados (a partir de 1995) até zero km, com parcelas fixas, prazos flexíveis (de 3 a 60 meses) e suporte completo para vistoria e documentação, garantindo praticidade e segurança na sua compra.',
      image: service7,
    },
    {
      name: 'credito-rural',
      title: 'Impulsione Seu Campo com Crédito!',
      description:
        'Desenvolvido especialmente para o produtor rural, o Crédito Rural é a ferramenta que impulsiona o crescimento do seu negócio. Com aprovação em até 24 horas e opções de pagamento único (em até 360 dias) ou parcelado (em até 24 vezes), essa linha de crédito facilita os investimentos na sua propriedade e a ampliação da produção.',
      image: service8,
    },
    {
      name: 'portabilidade-credito',
      title: 'Renegocie Seu Crédito e Economize!',
      description:
        'Reestruture suas dívidas transferindo seu empréstimo consignado para outra instituição financeira. Essa solução permite reduzir juros, liberar novo crédito e ajustar o valor das parcelas sem modificá-las, proporcionando maior flexibilidade e tranquilidade para o seu planejamento financeiro.',
      image: service9,
    },
    {
      name: 'refinanciamento',
      title: 'Renove Suas Finanças Hoje!',
      description:
        'Reestruture suas dívidas transferindo seu empréstimo consignado para outra instituição financeira. Essa solução permite reduzir juros, liberar novo crédito e ajustar o valor das parcelas sem modificá-las, proporcionando maior flexibilidade e tranquilidade para o seu planejamento financeiro.',
      image: service10,
    },
  ]

  return (
    <section id='nossos-servicos' className='flex w-full items-center justify-center bg-transparent'>
      <div className='my-10 flex w-11/12 flex-col items-center justify-center gap-8 md:w-10/12'>
        <header className='flex flex-col items-center justify-center gap-2 text-center'>
          <h2 className='text-4xl font-bold md:text-5xl'>Nossos Serviços</h2>
          <p className='w-full text-lg md:w-2/3'>
            Realize seus sonhos! Estamos aqui para oferecer o que você precisa, com taxas que cabem no seu bolso.
          </p>
        </header>

        <ul className='flex flex-wrap items-baseline gap-8'>
          {services.map((service, index) => {
            // Utiliza a imagem definida ou a padrão caso não haja.
            const serviceImage = service.image ? service.image : service1
            // Verifica se o card está expandido.
            const isExpanded = expandedIndex === index

            return (
              <li key={index} className='flex max-w-96 flex-col gap-2'>
                <img src={serviceImage} loading='lazy' alt={service.title} className='service-image w-96 rounded-xl' />
                <aside className='p-3'>
                  <h3 className='text-xl font-bold'>{service.title}</h3>
                  {/* Renderiza o parágrafo somente se o card estiver expandido */}
                  {isExpanded && <p>{service.description}</p>}
                  <button
                    onClick={() => toggleExpand(index)}
                    className='group mt-3 inline-flex items-center rounded-lg bg-[#FCB813] px-5 py-2 text-center font-semibold text-black shadow-md transition duration-300 ease-in-out hover:bg-[#e5a511] hover:shadow-lg'
                  >
                    <span>{isExpanded ? 'Mostrar Menos' : 'Saiba Mais'}</span>
                    <svg
                      className='ml-2 transition-transform duration-300 ease-in-out group-hover:rotate-45'
                      width='12'
                      height='14'
                      viewBox='0 0 12 14'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M1.0168 13.0311C1.28008 13.0289 1.53189 12.9213 1.71752 12.7317L10.0013 4.30536L10.0013 8.96462C10.0013 9.23384 10.1066 9.49205 10.294 9.68242C10.4814 9.87279 10.7356 9.97974 11.0006 9.97974C11.2657 9.97974 11.5199 9.87279 11.7073 9.68242C11.8947 9.49205 12 9.23384 12 8.96462L12 1.85875C11.9985 1.7258 11.9713 1.59444 11.92 1.47213C11.8186 1.22463 11.6249 1.02791 11.3813 0.924916C11.2608 0.872762 11.1315 0.845142 11.0006 0.843627L4.00512 0.843628C3.74007 0.843628 3.48588 0.950578 3.29846 1.14095C3.11105 1.33132 3.00576 1.58952 3.00576 1.85875C3.00576 2.12798 3.11105 2.38618 3.29846 2.57655C3.48588 2.76692 3.74007 2.87388 4.00512 2.87388L8.59203 2.87387L0.296556 11.2883C0.202605 11.3827 0.128019 11.4951 0.0771149 11.619C0.0262116 11.7429 8.54222e-07 11.8758 8.65777e-07 12.01C8.77332e-07 12.1442 0.0262117 12.2771 0.077115 12.401C0.128019 12.5249 0.202605 12.6373 0.296556 12.7317C0.390797 12.828 0.503097 12.9041 0.62681 12.9555C0.750525 13.0069 0.883136 13.0326 1.0168 13.0311Z'
                        fill='black'
                      ></path>
                    </svg>
                  </button>
                </aside>
              </li>
            )
          })}
        </ul>
      </div>
    </section>
  )
}

export default OurServices
